var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    { ref: "formActivity", attrs: { "lazy-validation": "" } },
    [
      _c(
        "v-col",
        { staticClass: "pt-0", attrs: { cols: "12" } },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "10" } },
                [
                  _c(
                    "v-radio-group",
                    {
                      staticClass:
                        "justify-center items-center align-center mt-0 pt-0",
                      style: { height: "40px" },
                      attrs: { row: "", "hide-details": "" },
                      model: {
                        value: _vm.comment.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.comment, "type", $$v)
                        },
                        expression: "comment.type",
                      },
                    },
                    [
                      _vm._l(_vm.commentTypesFiltered, function (type, i) {
                        return [
                          type.allow_user
                            ? _c("v-radio", {
                                key: i,
                                staticClass: "px-2",
                                attrs: {
                                  color: type.color,
                                  value: type.id,
                                  selected: "",
                                  "on-icon": type.icon,
                                  "off-icon": type.icon,
                                },
                              })
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.comment.type === _vm.$activityTypes.WHATSAPP
        ? _c(
            "v-col",
            [
              _vm.getTicket.wa_response
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "py-0 d-flex justify-end",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                loading: _vm.loadingMarkAsRead,
                                color: "primary",
                                "x-small": "",
                                outlined: "",
                                dark: "",
                              },
                              on: { click: _vm.markAsRead },
                            },
                            [_vm._v("\n          Marcar como leído\n        ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.getTicket.is_bot_stopped
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(
                              "Bot de Whatsapp activo en esta conversación"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                loading: _vm.loadingHandleWhatsappBotStatus,
                                color: "primary",
                                rounded: "",
                                small: "",
                              },
                              on: { click: _vm.onHandleWhatsappBotStatus },
                            },
                            [_vm._v("\n          Desactivar bot\n        ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.getTicket.is_bot_stopped && _vm.getBusiness.use_ia
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(
                              "Bot de Whatsapp detenido en esta conversación"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                loading: _vm.loadingHandleWhatsappBotStatus,
                                color: "primary",
                                rounded: "",
                                small: "",
                              },
                              on: { click: _vm.onHandleWhatsappBotStatus },
                            },
                            [_vm._v("\n          Activar bot\n        ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.getTicket.is_bot_stopped
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-select", {
                            attrs: {
                              rules: [_vm.$rules.REQUIRED],
                              items: _vm.getWhatsAppApps,
                              "item-text": (item) =>
                                `${item.verified_name} (${item.display_phone_number})`,
                              "item-value": "id",
                              label: "Responder desde",
                              "return-object": "",
                            },
                            model: {
                              value: _vm.whatsappApp,
                              callback: function ($$v) {
                                _vm.whatsappApp = $$v
                              },
                              expression: "whatsappApp",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "py-0 d-flex", attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            { staticClass: "my-auto" },
                            [
                              _c("v-checkbox", {
                                staticClass: "my-0 py-0",
                                style: { height: "24px" },
                                attrs: {
                                  label: "Enviar plantilla de mensaje",
                                  color: "accent",
                                  "hide-details": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onCheckWhatsappMessageTemplate(
                                      $event
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.useMessageTemplate,
                                  callback: function ($$v) {
                                    _vm.useMessageTemplate = $$v
                                  },
                                  expression: "useMessageTemplate",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _vm.whatsappApp && _vm.whatsappApp.platform !== "wweb"
                            ? _c(
                                "v-speed-dial",
                                {
                                  staticClass: "speed-dial-custom",
                                  attrs: {
                                    top: true,
                                    right: true,
                                    direction: "bottom",
                                    "open-on-hover": true,
                                    transition: "slide-y-transition",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { icon: "" },
                                                model: {
                                                  value: _vm.fab,
                                                  callback: function ($$v) {
                                                    _vm.fab = $$v
                                                  },
                                                  expression: "fab",
                                                },
                                              },
                                              [
                                                _vm.fab
                                                  ? _c(
                                                      "v-icon",
                                                      { attrs: { small: "" } },
                                                      [_vm._v(" fa fa-times ")]
                                                    )
                                                  : _c(
                                                      "v-icon",
                                                      { attrs: { small: "" } },
                                                      [
                                                        _vm._v(
                                                          " fas fa-paperclip "
                                                        ),
                                                      ]
                                                    ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    3034107207
                                  ),
                                  model: {
                                    value: _vm.fab,
                                    callback: function ($$v) {
                                      _vm.fab = $$v
                                    },
                                    expression: "fab",
                                  },
                                },
                                [
                                  _vm._v(" "),
                                  ["image", "document", "upload"].includes(
                                    _vm.whatsappMessageType
                                  )
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            fab: "",
                                            dark: "",
                                            small: "",
                                            color: "accent",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onChangeWhatsAppMessageType(
                                                "text"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("fas fa-align-center")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        fab: "",
                                        dark: "",
                                        small: "",
                                        color: "purple",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onChangeWhatsAppMessageType(
                                            "image"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("fas fa-image"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        fab: "",
                                        dark: "",
                                        small: "",
                                        color: "blue",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onChangeWhatsAppMessageType(
                                            "video"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("fas fa-video"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        fab: "",
                                        dark: "",
                                        small: "",
                                        color: "indigo",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onChangeWhatsAppMessageType(
                                            "document"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("fas fa-file"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        fab: "",
                                        dark: "",
                                        small: "",
                                        color: "orange",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onChangeWhatsAppMessageType(
                                            "upload"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("fas fa-upload"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.useMessageTemplate
                        ? [
                            _c(
                              "v-col",
                              { staticClass: "d-flex", attrs: { cols: "12" } },
                              [
                                _c("SelectMessageTemplates", {
                                  attrs: {
                                    "message-template-id":
                                      _vm.whatsappMessageTemplate,
                                    "is-required": false,
                                  },
                                  on: {
                                    "update:messageTemplateId": function (
                                      $event
                                    ) {
                                      _vm.whatsappMessageTemplate = $event
                                    },
                                    "update:message-template-id": function (
                                      $event
                                    ) {
                                      _vm.whatsappMessageTemplate = $event
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.whatsappMessageTemplate
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "ml-2 my-auto",
                                        attrs: { text: "", icon: "" },
                                        on: { click: _vm.onOpenModalPreview },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { dark: "", small: "" } },
                                          [_vm._v(" fas fa-eye ")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.messageTemplateSelected &&
                            _vm.messageTemplateSelected.body_params?.length
                              ? _c(
                                  "v-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "py-0",
                                            attrs: { cols: "12" },
                                          },
                                          [
                                            _c("h5", [
                                              _vm._v("Variables de plantilla"),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "text-caption mt-2 mb-0",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                Complete los siguientes campos para enviar la plantilla de mensaje correctamente.\n              "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.messageTemplateSelected
                                            .body_params,
                                          function (param) {
                                            return _c(
                                              "v-col",
                                              {
                                                key: param.name,
                                                attrs: { cols: "12" },
                                              },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "mb-4",
                                                  attrs: {
                                                    label: param.name,
                                                    rules: [
                                                      _vm.$rules.REQUIRED,
                                                    ],
                                                  },
                                                  model: {
                                                    value: param.value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        param,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "param.value",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      ["image", "document", "video"].includes(
                        _vm.whatsappMessageType
                      )
                        ? _c(
                            "v-col",
                            { staticClass: "d-flex" },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.filesFiltered,
                                  rules: [_vm.$rules.REQUIRED],
                                  label:
                                    _vm.whatsappMessageType === "image"
                                      ? "Imagen"
                                      : _vm.whatsappMessageType === "video"
                                      ? "Video"
                                      : "Documento",
                                  "item-value": "id",
                                  "item-text": "name",
                                },
                                model: {
                                  value: _vm.whatsappMessageMedia,
                                  callback: function ($$v) {
                                    _vm.whatsappMessageMedia = $$v
                                  },
                                  expression: "whatsappMessageMedia",
                                },
                              }),
                              _vm._v(" "),
                              _vm.whatsappMessageMedia
                                ? [
                                    _vm.whatsappMessageType === "image"
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          {
                                                            staticClass:
                                                              "ml-2 my-auto",
                                                            attrs: {
                                                              text: "",
                                                              icon: "",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.onOpenModalImageViewer,
                                                            },
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                dark: "",
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " fas fa-image "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3777248559
                                            ),
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("span", [_vm._v("Ver imagen")]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.whatsappMessageType === "document"
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          {
                                                            staticClass:
                                                              "ml-2 my-auto",
                                                            attrs: {
                                                              text: "",
                                                              icon: "",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.onOpenModalPreview,
                                                            },
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                dark: "",
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " fas fa-file-download "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1697338208
                                            ),
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v("Descargar documento"),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.whatsappMessageType === "upload"
                        ? _c(
                            "v-col",
                            [
                              _c("v-file-input", {
                                attrs: {
                                  label: "Archivo",
                                  accept:
                                    "text/plain, application/pdf, application/vnd.ms-powerpoint, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                  rules: [
                                    _vm.$rules.REQUIRED,
                                    _vm.fileType
                                      ? (v) =>
                                          (_vm.fileType &&
                                            v &&
                                            v.size < _vm.fileType.maxSize) ||
                                          `El archivo debe ser menor a ${
                                            _vm.fileType.maxSize / 1000000
                                          }MB`
                                      : true,
                                    (v) => {
                                      if (v && v.type.includes("image/")) {
                                        return "Tipo de archivo no válido"
                                      }
                                      return true
                                    },
                                  ],
                                  placeholder: "Seleccione archivo a enviar",
                                  "clear-icon": "fa-times",
                                  "truncate-length": "50",
                                  "prepend-icon": "",
                                  "show-size": "",
                                },
                                model: {
                                  value: _vm.fileContent,
                                  callback: function ($$v) {
                                    _vm.fileContent = $$v
                                  },
                                  expression: "fileContent",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.useMessageTemplate &&
      _vm.comment.type !== _vm.$activityTypes.EVENT &&
      (_vm.comment.type !== _vm.$activityTypes.WHATSAPP ||
        (_vm.comment.type === _vm.$activityTypes.WHATSAPP &&
          _vm.getTicket.is_bot_stopped))
        ? _c(
            "v-col",
            [
              _c("v-textarea", {
                staticClass: "expand",
                attrs: {
                  rules:
                    _vm.whatsappMessageType === "text"
                      ? [_vm.$rules.REQUIRED]
                      : [],
                  label:
                    _vm.whatsappMessageType === "text"
                      ? "Mensaje de texto"
                      : "Escribe un comentario...",
                  flat: "",
                  "auto-grow": "",
                  rows: "1",
                },
                model: {
                  value: _vm.comment.text,
                  callback: function ($$v) {
                    _vm.$set(_vm.comment, "text", $$v)
                  },
                  expression: "comment.text",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.responseErrorMessage
        ? _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-alert",
                { staticClass: "mb-0", attrs: { text: "", type: "error" } },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.responseErrorMessage) + "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      (_vm.comment.type !== _vm.$activityTypes.WHATSAPP &&
        _vm.comment.type !== _vm.$activityTypes.EVENT) ||
      (_vm.comment.type === _vm.$activityTypes.WHATSAPP &&
        _vm.getTicket.is_bot_stopped)
        ? _c(
            "v-btn",
            {
              staticClass: "mt-2",
              attrs: {
                color: _vm.getCommentTypes[_vm.comment.type].color,
                block: "",
                outlined: "",
                depressed: "",
                loading: _vm.loading,
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.onComment.apply(null, arguments)
                },
              },
            },
            [
              _c("v-icon", { attrs: { left: "", dark: "" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.getCommentTypes[_vm.comment.type].icon) +
                    "\n    "
                ),
              ]),
              _vm._v("\n    Comentar\n  "),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogPreview
        ? _c("ModalPreview", {
            attrs: {
              dialog: _vm.dialogPreview,
              "message-template-selected": _vm.messageTemplateSelected,
            },
            on: {
              "update:dialog": function ($event) {
                _vm.dialogPreview = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogImageViewer
        ? _c("ModalImageViewer", {
            attrs: {
              dialog: _vm.dialogImageViewer,
              url: _vm.messageMediaSelected,
            },
            on: {
              "update:dialog": function ($event) {
                _vm.dialogImageViewer = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogNewEvent
        ? _c("NewEvent", {
            attrs: { dialog: _vm.dialogNewEvent, "ticket-id": _vm.ticketId },
            on: {
              "update:dialog": [
                function ($event) {
                  _vm.dialogNewEvent = $event
                },
                _vm.onNewEventClose,
              ],
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }